/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { RepoScope, repoScopeFromJSON, repoScopeToJSON, repoScopeToNumber } from "../../permissions/v2/scopes";
import { ScanSummary } from "../../scan/v1/scan";

export const protobufPackage = "protos.projects.v1";

export enum Provider {
  UNSPECIFIED = "PROVIDER_UNSPECIFIED",
  GITHUB = "PROVIDER_GITHUB",
}

export function providerFromJSON(object: any): Provider {
  switch (object) {
    case 0:
    case "PROVIDER_UNSPECIFIED":
      return Provider.UNSPECIFIED;
    case 1:
    case "PROVIDER_GITHUB":
      return Provider.GITHUB;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Provider");
  }
}

export function providerToJSON(object: Provider): string {
  switch (object) {
    case Provider.UNSPECIFIED:
      return "PROVIDER_UNSPECIFIED";
    case Provider.GITHUB:
      return "PROVIDER_GITHUB";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Provider");
  }
}

export function providerToNumber(object: Provider): number {
  switch (object) {
    case Provider.UNSPECIFIED:
      return 0;
    case Provider.GITHUB:
      return 1;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Provider");
  }
}

export interface PolicySummary {
  slug: string;
  name: string;
}

export interface ProductIgnoredFilesMap {
  sast: string[];
  sca: string[];
  secrets: string[];
}

export interface ManagedScanSettings {
  diffScan: boolean;
  numConfigs?: number | undefined;
  fullScan: boolean;
}

export interface RepositoryRefItem {
  repoRefId: number;
  ref: string;
  isDefault: boolean;
  isPrimary: boolean;
}

/** TODO: reuse RepositoryRefItem for this */
export interface PrimaryRefItem {
  id?: number | undefined;
  ref?: string | undefined;
  isOverride: boolean;
}

/** TODO: reuse RepositoryRefItem for this */
export interface SimpleRefItem {
  id?: number | undefined;
  ref?: string | undefined;
}

export interface Repository {
  /** The unique identifier for the repository in the database */
  id: number;
  /** The name of this repository in Semgrep */
  name: string;
  /** The tags that have been applied to this repository */
  tags: string[];
  /** When this repository was first set up */
  provisionedAt?:
    | Date
    | undefined;
  /** The most-recent scan to complete while scanning this repository */
  latestScan?:
    | ScanSummary
    | undefined;
  /** The deployment_id that owns this repository and its scans */
  deploymentId: number;
  /** The URL for this repository (in an SCM like GitHub) */
  url?:
    | string
    | undefined;
  /** The list of files NOT to scan in this repository, if not the default */
  ignoredFiles: string[];
  /** The list of files NOT to scan just for particular products */
  productIgnoredFiles?:
    | ProductIgnoredFilesMap
    | undefined;
  /** The unique identifier of the first scan of this repository, if it exists */
  firstScanId?:
    | number
    | undefined;
  /** Whether or not this repository has been archived in the SCM */
  isArchived: boolean;
  /** Whether or not this repository has been disconnected from the SCM */
  isDisconnected: boolean;
  /** Whether or not code access has been granted for this repository */
  hasCodeAccess: boolean;
  /** A summary of the repository-wide SMS settings */
  managedScans?:
    | ManagedScanSettings
    | undefined;
  /** Whether or not the repository seems set up for Semgrep scanning of some kind */
  isSetup: boolean;
  /** When the repository most-recently synced with the SCM (in milliseconds!) */
  scmLastSyncedAt?:
    | number
    | undefined;
  /** For users with RBAC, the permissions available to this user on this repo */
  authorizedScopes: RepoScope[];
  /** The SCM for this user (TODO: there must be a better version of this supporting more than GitHub) */
  provider?:
    | Provider
    | undefined;
  /** The name of the default branch (TODO: Delete? I think this has been replaced with default_ref_info) */
  defaultBranch?:
    | string
    | undefined;
  /** All of the scanned refs for this project */
  refs: RepositoryRefItem[];
  /** The information about the primary ref, if it is set and requested */
  primaryRef?:
    | PrimaryRefItem
    | undefined;
  /** The information about the default ref, if it is known and requested */
  defaultRef?:
    | SimpleRefItem
    | undefined;
  /** TODO: possibly move this inside of the latest_scan object? */
  lastScannedRef?: SimpleRefItem | undefined;
}

export interface SingleBulkRepoChange {
  updateTags: boolean;
  tags: string[];
}

export interface BulkEditReposItem {
  repoId: number;
  change: SingleBulkRepoChange | undefined;
}

export interface BulkEditReposRequest {
  deploymentId: number;
  changes: BulkEditReposItem[];
}

export interface BulkEditReposResponse {
  /** once we make protos for Repository, this should be updated to return whole Repo objects */
  updatedRepoNames: string[];
}

export interface EditRepoRequest {
  deploymentId: number;
  idOrName: string;
  name?: string | undefined;
  managedScans?: ManagedScanSettings | undefined;
}

export interface EditRepoResponse {
  repo: Repository | undefined;
}

function createBasePolicySummary(): PolicySummary {
  return { slug: "", name: "" };
}

export const PolicySummary = {
  encode(message: PolicySummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.slug !== "") {
      writer.uint32(10).string(message.slug);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PolicySummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePolicySummary();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.slug = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PolicySummary {
    return { slug: isSet(object.slug) ? String(object.slug) : "", name: isSet(object.name) ? String(object.name) : "" };
  },

  toJSON(message: PolicySummary): unknown {
    const obj: any = {};
    if (message.slug !== "") {
      obj.slug = message.slug;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PolicySummary>, I>>(base?: I): PolicySummary {
    return PolicySummary.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PolicySummary>, I>>(object: I): PolicySummary {
    const message = createBasePolicySummary();
    message.slug = object.slug ?? "";
    message.name = object.name ?? "";
    return message;
  },
};

function createBaseProductIgnoredFilesMap(): ProductIgnoredFilesMap {
  return { sast: [], sca: [], secrets: [] };
}

export const ProductIgnoredFilesMap = {
  encode(message: ProductIgnoredFilesMap, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.sast) {
      writer.uint32(10).string(v!);
    }
    for (const v of message.sca) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.secrets) {
      writer.uint32(26).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProductIgnoredFilesMap {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProductIgnoredFilesMap();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.sast.push(reader.string());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.sca.push(reader.string());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.secrets.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProductIgnoredFilesMap {
    return {
      sast: Array.isArray(object?.sast) ? object.sast.map((e: any) => String(e)) : [],
      sca: Array.isArray(object?.sca) ? object.sca.map((e: any) => String(e)) : [],
      secrets: Array.isArray(object?.secrets) ? object.secrets.map((e: any) => String(e)) : [],
    };
  },

  toJSON(message: ProductIgnoredFilesMap): unknown {
    const obj: any = {};
    if (message.sast?.length) {
      obj.sast = message.sast;
    }
    if (message.sca?.length) {
      obj.sca = message.sca;
    }
    if (message.secrets?.length) {
      obj.secrets = message.secrets;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ProductIgnoredFilesMap>, I>>(base?: I): ProductIgnoredFilesMap {
    return ProductIgnoredFilesMap.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ProductIgnoredFilesMap>, I>>(object: I): ProductIgnoredFilesMap {
    const message = createBaseProductIgnoredFilesMap();
    message.sast = object.sast?.map((e) => e) || [];
    message.sca = object.sca?.map((e) => e) || [];
    message.secrets = object.secrets?.map((e) => e) || [];
    return message;
  },
};

function createBaseManagedScanSettings(): ManagedScanSettings {
  return { diffScan: false, numConfigs: undefined, fullScan: false };
}

export const ManagedScanSettings = {
  encode(message: ManagedScanSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.diffScan === true) {
      writer.uint32(8).bool(message.diffScan);
    }
    if (message.numConfigs !== undefined) {
      writer.uint32(16).int32(message.numConfigs);
    }
    if (message.fullScan === true) {
      writer.uint32(24).bool(message.fullScan);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ManagedScanSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseManagedScanSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.diffScan = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.numConfigs = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fullScan = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ManagedScanSettings {
    return {
      diffScan: isSet(object.diffScan) ? Boolean(object.diffScan) : false,
      numConfigs: isSet(object.numConfigs) ? Number(object.numConfigs) : undefined,
      fullScan: isSet(object.fullScan) ? Boolean(object.fullScan) : false,
    };
  },

  toJSON(message: ManagedScanSettings): unknown {
    const obj: any = {};
    if (message.diffScan === true) {
      obj.diffScan = message.diffScan;
    }
    if (message.numConfigs !== undefined) {
      obj.numConfigs = Math.round(message.numConfigs);
    }
    if (message.fullScan === true) {
      obj.fullScan = message.fullScan;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ManagedScanSettings>, I>>(base?: I): ManagedScanSettings {
    return ManagedScanSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ManagedScanSettings>, I>>(object: I): ManagedScanSettings {
    const message = createBaseManagedScanSettings();
    message.diffScan = object.diffScan ?? false;
    message.numConfigs = object.numConfigs ?? undefined;
    message.fullScan = object.fullScan ?? false;
    return message;
  },
};

function createBaseRepositoryRefItem(): RepositoryRefItem {
  return { repoRefId: 0, ref: "", isDefault: false, isPrimary: false };
}

export const RepositoryRefItem = {
  encode(message: RepositoryRefItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.repoRefId !== 0) {
      writer.uint32(8).uint64(message.repoRefId);
    }
    if (message.ref !== "") {
      writer.uint32(18).string(message.ref);
    }
    if (message.isDefault === true) {
      writer.uint32(24).bool(message.isDefault);
    }
    if (message.isPrimary === true) {
      writer.uint32(32).bool(message.isPrimary);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RepositoryRefItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepositoryRefItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.repoRefId = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.ref = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isDefault = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isPrimary = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepositoryRefItem {
    return {
      repoRefId: isSet(object.repoRefId) ? Number(object.repoRefId) : 0,
      ref: isSet(object.ref) ? String(object.ref) : "",
      isDefault: isSet(object.isDefault) ? Boolean(object.isDefault) : false,
      isPrimary: isSet(object.isPrimary) ? Boolean(object.isPrimary) : false,
    };
  },

  toJSON(message: RepositoryRefItem): unknown {
    const obj: any = {};
    if (message.repoRefId !== 0) {
      obj.repoRefId = Math.round(message.repoRefId);
    }
    if (message.ref !== "") {
      obj.ref = message.ref;
    }
    if (message.isDefault === true) {
      obj.isDefault = message.isDefault;
    }
    if (message.isPrimary === true) {
      obj.isPrimary = message.isPrimary;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RepositoryRefItem>, I>>(base?: I): RepositoryRefItem {
    return RepositoryRefItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RepositoryRefItem>, I>>(object: I): RepositoryRefItem {
    const message = createBaseRepositoryRefItem();
    message.repoRefId = object.repoRefId ?? 0;
    message.ref = object.ref ?? "";
    message.isDefault = object.isDefault ?? false;
    message.isPrimary = object.isPrimary ?? false;
    return message;
  },
};

function createBasePrimaryRefItem(): PrimaryRefItem {
  return { id: undefined, ref: undefined, isOverride: false };
}

export const PrimaryRefItem = {
  encode(message: PrimaryRefItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== undefined) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.ref !== undefined) {
      writer.uint32(18).string(message.ref);
    }
    if (message.isOverride === true) {
      writer.uint32(24).bool(message.isOverride);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PrimaryRefItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrimaryRefItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.ref = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isOverride = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrimaryRefItem {
    return {
      id: isSet(object.id) ? Number(object.id) : undefined,
      ref: isSet(object.ref) ? String(object.ref) : undefined,
      isOverride: isSet(object.isOverride) ? Boolean(object.isOverride) : false,
    };
  },

  toJSON(message: PrimaryRefItem): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = Math.round(message.id);
    }
    if (message.ref !== undefined) {
      obj.ref = message.ref;
    }
    if (message.isOverride === true) {
      obj.isOverride = message.isOverride;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PrimaryRefItem>, I>>(base?: I): PrimaryRefItem {
    return PrimaryRefItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PrimaryRefItem>, I>>(object: I): PrimaryRefItem {
    const message = createBasePrimaryRefItem();
    message.id = object.id ?? undefined;
    message.ref = object.ref ?? undefined;
    message.isOverride = object.isOverride ?? false;
    return message;
  },
};

function createBaseSimpleRefItem(): SimpleRefItem {
  return { id: undefined, ref: undefined };
}

export const SimpleRefItem = {
  encode(message: SimpleRefItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== undefined) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.ref !== undefined) {
      writer.uint32(18).string(message.ref);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SimpleRefItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSimpleRefItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.uint64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.ref = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SimpleRefItem {
    return {
      id: isSet(object.id) ? Number(object.id) : undefined,
      ref: isSet(object.ref) ? String(object.ref) : undefined,
    };
  },

  toJSON(message: SimpleRefItem): unknown {
    const obj: any = {};
    if (message.id !== undefined) {
      obj.id = Math.round(message.id);
    }
    if (message.ref !== undefined) {
      obj.ref = message.ref;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SimpleRefItem>, I>>(base?: I): SimpleRefItem {
    return SimpleRefItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SimpleRefItem>, I>>(object: I): SimpleRefItem {
    const message = createBaseSimpleRefItem();
    message.id = object.id ?? undefined;
    message.ref = object.ref ?? undefined;
    return message;
  },
};

function createBaseRepository(): Repository {
  return {
    id: 0,
    name: "",
    tags: [],
    provisionedAt: undefined,
    latestScan: undefined,
    deploymentId: 0,
    url: undefined,
    ignoredFiles: [],
    productIgnoredFiles: undefined,
    firstScanId: undefined,
    isArchived: false,
    isDisconnected: false,
    hasCodeAccess: false,
    managedScans: undefined,
    isSetup: false,
    scmLastSyncedAt: undefined,
    authorizedScopes: [],
    provider: undefined,
    defaultBranch: undefined,
    refs: [],
    primaryRef: undefined,
    defaultRef: undefined,
    lastScannedRef: undefined,
  };
}

export const Repository = {
  encode(message: Repository, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    for (const v of message.tags) {
      writer.uint32(26).string(v!);
    }
    if (message.provisionedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.provisionedAt), writer.uint32(34).fork()).ldelim();
    }
    if (message.latestScan !== undefined) {
      ScanSummary.encode(message.latestScan, writer.uint32(42).fork()).ldelim();
    }
    if (message.deploymentId !== 0) {
      writer.uint32(48).int64(message.deploymentId);
    }
    if (message.url !== undefined) {
      writer.uint32(58).string(message.url);
    }
    for (const v of message.ignoredFiles) {
      writer.uint32(66).string(v!);
    }
    if (message.productIgnoredFiles !== undefined) {
      ProductIgnoredFilesMap.encode(message.productIgnoredFiles, writer.uint32(74).fork()).ldelim();
    }
    if (message.firstScanId !== undefined) {
      writer.uint32(80).uint64(message.firstScanId);
    }
    if (message.isArchived === true) {
      writer.uint32(88).bool(message.isArchived);
    }
    if (message.isDisconnected === true) {
      writer.uint32(96).bool(message.isDisconnected);
    }
    if (message.hasCodeAccess === true) {
      writer.uint32(104).bool(message.hasCodeAccess);
    }
    if (message.managedScans !== undefined) {
      ManagedScanSettings.encode(message.managedScans, writer.uint32(114).fork()).ldelim();
    }
    if (message.isSetup === true) {
      writer.uint32(120).bool(message.isSetup);
    }
    if (message.scmLastSyncedAt !== undefined) {
      writer.uint32(133).float(message.scmLastSyncedAt);
    }
    writer.uint32(138).fork();
    for (const v of message.authorizedScopes) {
      writer.int32(repoScopeToNumber(v));
    }
    writer.ldelim();
    if (message.provider !== undefined) {
      writer.uint32(144).int32(providerToNumber(message.provider));
    }
    if (message.defaultBranch !== undefined) {
      writer.uint32(154).string(message.defaultBranch);
    }
    for (const v of message.refs) {
      RepositoryRefItem.encode(v!, writer.uint32(162).fork()).ldelim();
    }
    if (message.primaryRef !== undefined) {
      PrimaryRefItem.encode(message.primaryRef, writer.uint32(170).fork()).ldelim();
    }
    if (message.defaultRef !== undefined) {
      SimpleRefItem.encode(message.defaultRef, writer.uint32(178).fork()).ldelim();
    }
    if (message.lastScannedRef !== undefined) {
      SimpleRefItem.encode(message.lastScannedRef, writer.uint32(186).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Repository {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepository();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.tags.push(reader.string());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.provisionedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.latestScan = ScanSummary.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.url = reader.string();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.ignoredFiles.push(reader.string());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.productIgnoredFiles = ProductIgnoredFilesMap.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.firstScanId = longToNumber(reader.uint64() as Long);
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.isArchived = reader.bool();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.isDisconnected = reader.bool();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.hasCodeAccess = reader.bool();
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.managedScans = ManagedScanSettings.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.isSetup = reader.bool();
          continue;
        case 16:
          if (tag !== 133) {
            break;
          }

          message.scmLastSyncedAt = reader.float();
          continue;
        case 17:
          if (tag === 136) {
            message.authorizedScopes.push(repoScopeFromJSON(reader.int32()));

            continue;
          }

          if (tag === 138) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.authorizedScopes.push(repoScopeFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.provider = providerFromJSON(reader.int32());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.defaultBranch = reader.string();
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.refs.push(RepositoryRefItem.decode(reader, reader.uint32()));
          continue;
        case 21:
          if (tag !== 170) {
            break;
          }

          message.primaryRef = PrimaryRefItem.decode(reader, reader.uint32());
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.defaultRef = SimpleRefItem.decode(reader, reader.uint32());
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.lastScannedRef = SimpleRefItem.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Repository {
    return {
      id: isSet(object.id) ? Number(object.id) : 0,
      name: isSet(object.name) ? String(object.name) : "",
      tags: Array.isArray(object?.tags) ? object.tags.map((e: any) => String(e)) : [],
      provisionedAt: isSet(object.provisionedAt) ? fromJsonTimestamp(object.provisionedAt) : undefined,
      latestScan: isSet(object.latestScan) ? ScanSummary.fromJSON(object.latestScan) : undefined,
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      url: isSet(object.url) ? String(object.url) : undefined,
      ignoredFiles: Array.isArray(object?.ignoredFiles) ? object.ignoredFiles.map((e: any) => String(e)) : [],
      productIgnoredFiles: isSet(object.productIgnoredFiles)
        ? ProductIgnoredFilesMap.fromJSON(object.productIgnoredFiles)
        : undefined,
      firstScanId: isSet(object.firstScanId) ? Number(object.firstScanId) : undefined,
      isArchived: isSet(object.isArchived) ? Boolean(object.isArchived) : false,
      isDisconnected: isSet(object.isDisconnected) ? Boolean(object.isDisconnected) : false,
      hasCodeAccess: isSet(object.hasCodeAccess) ? Boolean(object.hasCodeAccess) : false,
      managedScans: isSet(object.managedScans) ? ManagedScanSettings.fromJSON(object.managedScans) : undefined,
      isSetup: isSet(object.isSetup) ? Boolean(object.isSetup) : false,
      scmLastSyncedAt: isSet(object.scmLastSyncedAt) ? Number(object.scmLastSyncedAt) : undefined,
      authorizedScopes: Array.isArray(object?.authorizedScopes)
        ? object.authorizedScopes.map((e: any) => repoScopeFromJSON(e))
        : [],
      provider: isSet(object.provider) ? providerFromJSON(object.provider) : undefined,
      defaultBranch: isSet(object.defaultBranch) ? String(object.defaultBranch) : undefined,
      refs: Array.isArray(object?.refs) ? object.refs.map((e: any) => RepositoryRefItem.fromJSON(e)) : [],
      primaryRef: isSet(object.primaryRef) ? PrimaryRefItem.fromJSON(object.primaryRef) : undefined,
      defaultRef: isSet(object.defaultRef) ? SimpleRefItem.fromJSON(object.defaultRef) : undefined,
      lastScannedRef: isSet(object.lastScannedRef) ? SimpleRefItem.fromJSON(object.lastScannedRef) : undefined,
    };
  },

  toJSON(message: Repository): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    if (message.provisionedAt !== undefined) {
      obj.provisionedAt = message.provisionedAt.toISOString();
    }
    if (message.latestScan !== undefined) {
      obj.latestScan = ScanSummary.toJSON(message.latestScan);
    }
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.url !== undefined) {
      obj.url = message.url;
    }
    if (message.ignoredFiles?.length) {
      obj.ignoredFiles = message.ignoredFiles;
    }
    if (message.productIgnoredFiles !== undefined) {
      obj.productIgnoredFiles = ProductIgnoredFilesMap.toJSON(message.productIgnoredFiles);
    }
    if (message.firstScanId !== undefined) {
      obj.firstScanId = Math.round(message.firstScanId);
    }
    if (message.isArchived === true) {
      obj.isArchived = message.isArchived;
    }
    if (message.isDisconnected === true) {
      obj.isDisconnected = message.isDisconnected;
    }
    if (message.hasCodeAccess === true) {
      obj.hasCodeAccess = message.hasCodeAccess;
    }
    if (message.managedScans !== undefined) {
      obj.managedScans = ManagedScanSettings.toJSON(message.managedScans);
    }
    if (message.isSetup === true) {
      obj.isSetup = message.isSetup;
    }
    if (message.scmLastSyncedAt !== undefined) {
      obj.scmLastSyncedAt = message.scmLastSyncedAt;
    }
    if (message.authorizedScopes?.length) {
      obj.authorizedScopes = message.authorizedScopes.map((e) => repoScopeToJSON(e));
    }
    if (message.provider !== undefined) {
      obj.provider = providerToJSON(message.provider);
    }
    if (message.defaultBranch !== undefined) {
      obj.defaultBranch = message.defaultBranch;
    }
    if (message.refs?.length) {
      obj.refs = message.refs.map((e) => RepositoryRefItem.toJSON(e));
    }
    if (message.primaryRef !== undefined) {
      obj.primaryRef = PrimaryRefItem.toJSON(message.primaryRef);
    }
    if (message.defaultRef !== undefined) {
      obj.defaultRef = SimpleRefItem.toJSON(message.defaultRef);
    }
    if (message.lastScannedRef !== undefined) {
      obj.lastScannedRef = SimpleRefItem.toJSON(message.lastScannedRef);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Repository>, I>>(base?: I): Repository {
    return Repository.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Repository>, I>>(object: I): Repository {
    const message = createBaseRepository();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.tags = object.tags?.map((e) => e) || [];
    message.provisionedAt = object.provisionedAt ?? undefined;
    message.latestScan = (object.latestScan !== undefined && object.latestScan !== null)
      ? ScanSummary.fromPartial(object.latestScan)
      : undefined;
    message.deploymentId = object.deploymentId ?? 0;
    message.url = object.url ?? undefined;
    message.ignoredFiles = object.ignoredFiles?.map((e) => e) || [];
    message.productIgnoredFiles = (object.productIgnoredFiles !== undefined && object.productIgnoredFiles !== null)
      ? ProductIgnoredFilesMap.fromPartial(object.productIgnoredFiles)
      : undefined;
    message.firstScanId = object.firstScanId ?? undefined;
    message.isArchived = object.isArchived ?? false;
    message.isDisconnected = object.isDisconnected ?? false;
    message.hasCodeAccess = object.hasCodeAccess ?? false;
    message.managedScans = (object.managedScans !== undefined && object.managedScans !== null)
      ? ManagedScanSettings.fromPartial(object.managedScans)
      : undefined;
    message.isSetup = object.isSetup ?? false;
    message.scmLastSyncedAt = object.scmLastSyncedAt ?? undefined;
    message.authorizedScopes = object.authorizedScopes?.map((e) => e) || [];
    message.provider = object.provider ?? undefined;
    message.defaultBranch = object.defaultBranch ?? undefined;
    message.refs = object.refs?.map((e) => RepositoryRefItem.fromPartial(e)) || [];
    message.primaryRef = (object.primaryRef !== undefined && object.primaryRef !== null)
      ? PrimaryRefItem.fromPartial(object.primaryRef)
      : undefined;
    message.defaultRef = (object.defaultRef !== undefined && object.defaultRef !== null)
      ? SimpleRefItem.fromPartial(object.defaultRef)
      : undefined;
    message.lastScannedRef = (object.lastScannedRef !== undefined && object.lastScannedRef !== null)
      ? SimpleRefItem.fromPartial(object.lastScannedRef)
      : undefined;
    return message;
  },
};

function createBaseSingleBulkRepoChange(): SingleBulkRepoChange {
  return { updateTags: false, tags: [] };
}

export const SingleBulkRepoChange = {
  encode(message: SingleBulkRepoChange, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.updateTags === true) {
      writer.uint32(8).bool(message.updateTags);
    }
    for (const v of message.tags) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SingleBulkRepoChange {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSingleBulkRepoChange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.updateTags = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tags.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SingleBulkRepoChange {
    return {
      updateTags: isSet(object.updateTags) ? Boolean(object.updateTags) : false,
      tags: Array.isArray(object?.tags) ? object.tags.map((e: any) => String(e)) : [],
    };
  },

  toJSON(message: SingleBulkRepoChange): unknown {
    const obj: any = {};
    if (message.updateTags === true) {
      obj.updateTags = message.updateTags;
    }
    if (message.tags?.length) {
      obj.tags = message.tags;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SingleBulkRepoChange>, I>>(base?: I): SingleBulkRepoChange {
    return SingleBulkRepoChange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SingleBulkRepoChange>, I>>(object: I): SingleBulkRepoChange {
    const message = createBaseSingleBulkRepoChange();
    message.updateTags = object.updateTags ?? false;
    message.tags = object.tags?.map((e) => e) || [];
    return message;
  },
};

function createBaseBulkEditReposItem(): BulkEditReposItem {
  return { repoId: 0, change: undefined };
}

export const BulkEditReposItem = {
  encode(message: BulkEditReposItem, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.repoId !== 0) {
      writer.uint32(8).int32(message.repoId);
    }
    if (message.change !== undefined) {
      SingleBulkRepoChange.encode(message.change, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BulkEditReposItem {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditReposItem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.repoId = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.change = SingleBulkRepoChange.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditReposItem {
    return {
      repoId: isSet(object.repoId) ? Number(object.repoId) : 0,
      change: isSet(object.change) ? SingleBulkRepoChange.fromJSON(object.change) : undefined,
    };
  },

  toJSON(message: BulkEditReposItem): unknown {
    const obj: any = {};
    if (message.repoId !== 0) {
      obj.repoId = Math.round(message.repoId);
    }
    if (message.change !== undefined) {
      obj.change = SingleBulkRepoChange.toJSON(message.change);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditReposItem>, I>>(base?: I): BulkEditReposItem {
    return BulkEditReposItem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditReposItem>, I>>(object: I): BulkEditReposItem {
    const message = createBaseBulkEditReposItem();
    message.repoId = object.repoId ?? 0;
    message.change = (object.change !== undefined && object.change !== null)
      ? SingleBulkRepoChange.fromPartial(object.change)
      : undefined;
    return message;
  },
};

function createBaseBulkEditReposRequest(): BulkEditReposRequest {
  return { deploymentId: 0, changes: [] };
}

export const BulkEditReposRequest = {
  encode(message: BulkEditReposRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    for (const v of message.changes) {
      BulkEditReposItem.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BulkEditReposRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditReposRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.changes.push(BulkEditReposItem.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditReposRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      changes: Array.isArray(object?.changes) ? object.changes.map((e: any) => BulkEditReposItem.fromJSON(e)) : [],
    };
  },

  toJSON(message: BulkEditReposRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.changes?.length) {
      obj.changes = message.changes.map((e) => BulkEditReposItem.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditReposRequest>, I>>(base?: I): BulkEditReposRequest {
    return BulkEditReposRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditReposRequest>, I>>(object: I): BulkEditReposRequest {
    const message = createBaseBulkEditReposRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.changes = object.changes?.map((e) => BulkEditReposItem.fromPartial(e)) || [];
    return message;
  },
};

function createBaseBulkEditReposResponse(): BulkEditReposResponse {
  return { updatedRepoNames: [] };
}

export const BulkEditReposResponse = {
  encode(message: BulkEditReposResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.updatedRepoNames) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BulkEditReposResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBulkEditReposResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.updatedRepoNames.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BulkEditReposResponse {
    return {
      updatedRepoNames: Array.isArray(object?.updatedRepoNames)
        ? object.updatedRepoNames.map((e: any) => String(e))
        : [],
    };
  },

  toJSON(message: BulkEditReposResponse): unknown {
    const obj: any = {};
    if (message.updatedRepoNames?.length) {
      obj.updatedRepoNames = message.updatedRepoNames;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BulkEditReposResponse>, I>>(base?: I): BulkEditReposResponse {
    return BulkEditReposResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BulkEditReposResponse>, I>>(object: I): BulkEditReposResponse {
    const message = createBaseBulkEditReposResponse();
    message.updatedRepoNames = object.updatedRepoNames?.map((e) => e) || [];
    return message;
  },
};

function createBaseEditRepoRequest(): EditRepoRequest {
  return { deploymentId: 0, idOrName: "", name: undefined, managedScans: undefined };
}

export const EditRepoRequest = {
  encode(message: EditRepoRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deploymentId !== 0) {
      writer.uint32(8).int64(message.deploymentId);
    }
    if (message.idOrName !== "") {
      writer.uint32(18).string(message.idOrName);
    }
    if (message.name !== undefined) {
      writer.uint32(26).string(message.name);
    }
    if (message.managedScans !== undefined) {
      ManagedScanSettings.encode(message.managedScans, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditRepoRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditRepoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deploymentId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.idOrName = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.managedScans = ManagedScanSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditRepoRequest {
    return {
      deploymentId: isSet(object.deploymentId) ? Number(object.deploymentId) : 0,
      idOrName: isSet(object.idOrName) ? String(object.idOrName) : "",
      name: isSet(object.name) ? String(object.name) : undefined,
      managedScans: isSet(object.managedScans) ? ManagedScanSettings.fromJSON(object.managedScans) : undefined,
    };
  },

  toJSON(message: EditRepoRequest): unknown {
    const obj: any = {};
    if (message.deploymentId !== 0) {
      obj.deploymentId = Math.round(message.deploymentId);
    }
    if (message.idOrName !== "") {
      obj.idOrName = message.idOrName;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.managedScans !== undefined) {
      obj.managedScans = ManagedScanSettings.toJSON(message.managedScans);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditRepoRequest>, I>>(base?: I): EditRepoRequest {
    return EditRepoRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditRepoRequest>, I>>(object: I): EditRepoRequest {
    const message = createBaseEditRepoRequest();
    message.deploymentId = object.deploymentId ?? 0;
    message.idOrName = object.idOrName ?? "";
    message.name = object.name ?? undefined;
    message.managedScans = (object.managedScans !== undefined && object.managedScans !== null)
      ? ManagedScanSettings.fromPartial(object.managedScans)
      : undefined;
    return message;
  },
};

function createBaseEditRepoResponse(): EditRepoResponse {
  return { repo: undefined };
}

export const EditRepoResponse = {
  encode(message: EditRepoResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.repo !== undefined) {
      Repository.encode(message.repo, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EditRepoResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEditRepoResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.repo = Repository.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EditRepoResponse {
    return { repo: isSet(object.repo) ? Repository.fromJSON(object.repo) : undefined };
  },

  toJSON(message: EditRepoResponse): unknown {
    const obj: any = {};
    if (message.repo !== undefined) {
      obj.repo = Repository.toJSON(message.repo);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EditRepoResponse>, I>>(base?: I): EditRepoResponse {
    return EditRepoResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EditRepoResponse>, I>>(object: I): EditRepoResponse {
    const message = createBaseEditRepoResponse();
    message.repo = (object.repo !== undefined && object.repo !== null)
      ? Repository.fromPartial(object.repo)
      : undefined;
    return message;
  },
};

export interface SupportService {
  bulkEditRepos(request: BulkEditReposRequest): Promise<BulkEditReposResponse>;
  editRepo(request: EditRepoRequest): Promise<EditRepoResponse>;
}

export const SupportServiceServiceName = "protos.projects.v1.SupportService";
export class SupportServiceClientImpl implements SupportService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || SupportServiceServiceName;
    this.rpc = rpc;
    this.bulkEditRepos = this.bulkEditRepos.bind(this);
    this.editRepo = this.editRepo.bind(this);
  }
  bulkEditRepos(request: BulkEditReposRequest): Promise<BulkEditReposResponse> {
    const data = BulkEditReposRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "BulkEditRepos", data);
    return promise.then((data) => BulkEditReposResponse.decode(_m0.Reader.create(data)));
  }

  editRepo(request: EditRepoRequest): Promise<EditRepoResponse> {
    const data = EditRepoRequest.encode(request).finish();
    const promise = this.rpc.request(this.service, "EditRepo", data);
    return promise.then((data) => EditRepoResponse.decode(_m0.Reader.create(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

declare const self: any | undefined;
declare const window: any | undefined;
declare const global: any | undefined;
const tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = date.getTime() / 1_000;
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(Number.MAX_SAFE_INTEGER)) {
    throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
